// Tiny, framework-agnostic toast bus. `toast(msg)` can be called from anywhere —
// helpers, event handlers, libs — and the <ToastHost/> mounted once in main.tsx
// renders the queue. Keeping the emitter out of React avoids any provider wiring.

type ToastListener = (message: string) => void;

const listeners = new Set<ToastListener>();

/** Show a brief, auto-dismissing confirmation toast. */
export function toast(message: string): void {
  for (const listener of listeners) listener(message);
}

/** Subscribe to toast messages; returns an unsubscribe fn (for the host effect). */
export function subscribeToast(listener: ToastListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
